/** 常用区号；code 为国际区号数字（不含 +） */
export const PHONE_COUNTRY_OPTIONS = [
  { code: '86', label: '中国大陆', dialLabel: '+86' },
  { code: '852', label: '中国香港', dialLabel: '+852' },
  { code: '853', label: '中国澳门', dialLabel: '+853' },
  { code: '886', label: '中国台湾', dialLabel: '+886' },
  { code: '81', label: '日本', dialLabel: '+81' },
  { code: '82', label: '韩国', dialLabel: '+82' },
  { code: '91', label: '印度', dialLabel: '+91' },
  { code: '65', label: '新加坡', dialLabel: '+65' },
  { code: '60', label: '马来西亚', dialLabel: '+60' },
  { code: '66', label: '泰国', dialLabel: '+66' },
  { code: '84', label: '越南', dialLabel: '+84' },
  { code: '62', label: '印度尼西亚', dialLabel: '+62' },
  { code: '63', label: '菲律宾', dialLabel: '+63' },
  { code: '95', label: '缅甸', dialLabel: '+95' },
  { code: '855', label: '柬埔寨', dialLabel: '+855' },
  { code: '856', label: '老挝', dialLabel: '+856' },
  { code: '673', label: '文莱', dialLabel: '+673' },
  { code: '670', label: '东帝汶', dialLabel: '+670' },
  { code: '971', label: '阿联酋', dialLabel: '+971' },
  { code: '966', label: '沙特阿拉伯', dialLabel: '+966' },
  { code: '974', label: '卡塔尔', dialLabel: '+974' },
  { code: '965', label: '科威特', dialLabel: '+965' },
  { code: '973', label: '巴林', dialLabel: '+973' },
  { code: '968', label: '阿曼', dialLabel: '+968' },
  { code: '962', label: '约旦', dialLabel: '+962' },
  { code: '961', label: '黎巴嫩', dialLabel: '+961' },
  { code: '964', label: '伊拉克', dialLabel: '+964' },
  { code: '98', label: '伊朗', dialLabel: '+98' },
  { code: '972', label: '以色列', dialLabel: '+972' },
  { code: '970', label: '巴勒斯坦', dialLabel: '+970' },
  { code: '967', label: '也门', dialLabel: '+967' },
  { code: '20', label: '埃及', dialLabel: '+20' },
  { code: '90', label: '土耳其', dialLabel: '+90' },
  { code: '1', label: '美国/加拿大', dialLabel: '+1' },
  { code: '44', label: '英国', dialLabel: '+44' },
  { code: '61', label: '澳大利亚', dialLabel: '+61' },
  { code: '64', label: '新西兰', dialLabel: '+64' },
  { code: '49', label: '德国', dialLabel: '+49' },
  { code: '33', label: '法国', dialLabel: '+33' }
]

/**
 * 提交/落库 phone：
 * - 大陆 +86：11 位纯号
 * - 其他：E.164，如 +852xxxxxxxx
 */
export function buildPhoneForSubmit(countryCode, phoneDigits) {
  const digits = String(phoneDigits != null ? phoneDigits : '').replace(/\D/g, '')
  if (!digits) return ''
  const code = countryCode || '86'
  if (code === '86') {
    return /^1\d{10}$/.test(digits) ? digits : ''
  }
  if (digits.length < 6 || digits.length > 15) return ''
  return `+${code}${digits}`
}

/** @returns {string} 错误文案；空串表示通过 */
export function validatePhoneDigits(countryCode, phoneDigits) {
  const digits = String(phoneDigits != null ? phoneDigits : '').replace(/\D/g, '')
  if (!digits) return '请输入手机号'
  const code = countryCode || '86'
  if (code === '86') {
    if (!/^1\d{10}$/.test(digits)) return '请输入正确的大陆手机号'
  } else if (digits.length < 6 || digits.length > 15) {
    return '请输入正确的手机号'
  }
  return ''
}

/** 从已存 phone 还原区号与本地号 */
export function parseStoredPhone(stored) {
  const raw = String(stored != null ? stored : '').trim()
  if (!raw) return { countryCode: '86', phone: '' }
  if (raw.startsWith('+')) {
    const rest = raw.slice(1).replace(/\D/g, '')
    const sorted = PHONE_COUNTRY_OPTIONS.slice().sort((a, b) => b.code.length - a.code.length)
    for (let i = 0; i < sorted.length; i += 1) {
      const c = sorted[i]
      if (rest.startsWith(c.code)) {
        return { countryCode: c.code, phone: rest.slice(c.code.length) }
      }
    }
    return { countryCode: '86', phone: rest }
  }
  const digits = raw.replace(/\D/g, '')
  return { countryCode: '86', phone: digits }
}
